import React from "react";

export default function Point(props) {
  return (
    <div className="point">
      <p>{props.point}</p>
    </div>
  );
}
